// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G89h","content":"styles_content__zXbCd","tableWrap":"styles_tableWrap__3y9Lw"};